<template>
  <div id="main-pos">
    <header
      ref="header"
      class="common-header"
    >
      <slot name="header"/>
    </header>

    <div
      :style="[{ 'padding-top': `${mainOffsetTop}px` }]"
      class="main"
    >
      <slot name="content"/>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      mainOffsetTop: 0,
    }
  },

  mounted () {
    this.setUI()
    window.addEventListener('resize', this.handleWindowResize)
  },

  destroyed () {
    window.removeEventListener('resize', this.handleWindowResize, false)
  },

  methods: {
    handleWindowResize() {
      this.setUI()
    },
    setUI() {
      this.$nextTick(() => {
        const header = this.$refs['header']
        if (header) {
          this.mainOffsetTop = header.clientHeight
        }
      })
    },
  },
}
</script>

<style scoped>
.main {
  margin: auto;
  position: relative;
}

.common-header {
  display: flex;
  align-items: center;
  padding: 0 15px;
}

.common-header > div {
  flex: 1;
}

.common-header /deep/ button.btn {
  font-size: 18px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/apps/pos/sale/mobile/common/ContentWithHeader.vue